<script setup>
import AuthIframe from "./AuthIframe";
</script>

<template>
  <AuthIframe source="auth/join" />
</template>
